const downloadProtectedMedia = {
  downloadFile: Drupal.t('Download file'),
  modal: {
    enterPassword: Drupal.t('Enter password'),
    password: Drupal.t('Password'),
    description: Drupal.t(
      'This download is password-protected. Reach out to your local contact in case you don’t have a password yet.',
    ),
    submitButton: Drupal.t('Submit password'),
    submitting: Drupal.t('Downloading...'),
  },
};

export default downloadProtectedMedia;
